import { MlsMapperEventKeys } from '@/constants/MlsMapperEventKeys';
import { MlsMapperEventTypes } from '@/constants/MlsMapperEventTypes';

/**
 * This is the structure of the messages we send to the MLS Mapper iframe.
 */
export default interface IMlsMapperMessage {
    type: MlsMapperEventTypes;
    method: string;
    key: MlsMapperEventKeys;
    data: string;
}

export function newMlsMapperMessage(): IMlsMapperMessage {
    const message: IMlsMapperMessage = {
        type: MlsMapperEventTypes.storage,
        method: 'set',
        key: MlsMapperEventKeys.none,
        data: ''
    };
    return message;
}
